export default __webpack_public_path__ + "static/media/eye-close-dark.a54ecc53.svg";